import { Avatar } from "@admin/components/atoms/Avatar";
import { CompanyLocation } from "@enos-monorepo/lib";
import { useTranslation } from "react-i18next";

interface LocationInfoProps {
  selectedLocation?: CompanyLocation;
  date?: Date;
  description?: string;
}

export function LocationInfo({
  selectedLocation,
  date,
  description,
}: LocationInfoProps) {
  const { i18n } = useTranslation();

  if (selectedLocation) {
    return (
      <div className="flex flex-row gap-[25px]">
        <Avatar
          src={selectedLocation.avatarPhoto}
          size="xl"
          alt={selectedLocation.name}
        />
        <div className="flex flex-col gap-2.5 justify-center">
          <h2 className="font-semibold text-[18px]">
            {selectedLocation.name} {description}
            {date &&
              ` (${new Intl.DateTimeFormat(i18n.language, {
                month: "short",
                day: "numeric",
                year: "numeric",
              })
                .format(date)
                .replace(/(\d{1,2} \w{3}) (\d{4})/, "$1, $2")})`}
          </h2>
          <span className="flex flex-row gap-[5px] items-center">
            <i className="ki-filled ki-geolocation"></i>
            <span className="text-[#A1A5B7] text-[15px] font-semibold">
              {selectedLocation.address}
            </span>
          </span>
        </div>
      </div>
    );
  }

  return null;
}
